import { render, staticRenderFns } from "./scheduleBlock.vue?vue&type=template&id=35c0b9b1&"
import script from "./scheduleBlock.vue?vue&type=script&lang=js&"
export * from "./scheduleBlock.vue?vue&type=script&lang=js&"
import style0 from "./scheduleBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports